import { createApi } from '@reduxjs/toolkit/query/react';
import { CreateTagDto, IPagedCollection, IPagingData, TagDto, UpdateTagDto } from '@sr/dto';
import { TAGS_BASE_URL } from 'shared/api/api';
import { createBaseQuery } from 'shared/api/rtk-query';

const api = createApi({
  baseQuery: createBaseQuery(TAGS_BASE_URL),
  reducerPath: 'tags',
  endpoints: (builder) => ({
    getAll: builder.query<IPagedCollection<TagDto>, {paging: IPagingData}>({
      query: ({paging}) => `?page=${paging.page}&itemsPerPage=${paging.itemsPerPage}`,
    }),

    get: builder.query<TagDto, number>({
      query: (id) => `${id}`
    }),

    create: builder.mutation<TagDto, CreateTagDto>({
      query: (data) => ({
        url: '',
        method: 'POST',
        body: data
      })
    }),

    update: builder.mutation<TagDto, UpdateTagDto>({
      query: (dto) => ({
        url: `${dto.id}`,
        method: 'PUT',
        body: dto
      })
    }),
    delete: builder.mutation<void, number>({
      query: (id) => ({
        url: `${id}`,
        method: 'DELETE'
      })
    })
  })
});

export const tagsApi = api.enhanceEndpoints({
  addTagTypes: ['tags'],
  endpoints: {
    getAll: {
      providesTags: (result, error, arg) => {
        const pageKey = `PAGE-${arg.paging.page}-${arg.paging.itemsPerPage}`;
        return [{ type: 'tags', id: pageKey }];
      }
    },
    create: {
      invalidatesTags: ['tags']
    },
    delete: {
      invalidatesTags: ['tags']
    },
    update: {
      invalidatesTags: ['tags']
    },
    get: {
      providesTags: (result, error, id) => [{ type: 'tags', id }]
    }
  }
});
